import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { RouterModule } from '@angular/router';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { UIModule } from './ui/ui.module';
import { LayoutsModule } from './layouts/layouts.module';
import { FormsModule as CustomFormsModule } from './forms/forms.module';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { MaterialModule } from './material.module';
import { FlexLayoutModule } from '@angular/flex-layout';

@NgModule({
  exports: [
    CommonModule,
    CustomFormsModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    RouterModule,
    UIModule,
    LayoutsModule,
    MaterialModule,
    FlexLayoutModule,
  ],
  imports: [MaterialModule],
})
export class SharedModule {}
